import { render, staticRenderFns } from "./ModalInputOther.vue?vue&type=template&id=153b7b18"
import script from "./ModalInputOther.vue?vue&type=script&lang=js"
export * from "./ModalInputOther.vue?vue&type=script&lang=js"
import style0 from "./ModalInputOther.vue?vue&type=style&index=0&id=153b7b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports